import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { Courthouse } from './Courthouse';
export class Courtroom {
    /**
     * A room in a courthouse where hearings take place
     * @param id Identifies the courtroom
     * @param name The name or number of the courtroom
     * @param courtSystemId Which courtsystem the courtroom belongs to
     * @param status The status of this courtroom, i.e. active, archived or historical
     * @param courthouse The courthouse that the courtroom is in (undefined if not loaded by the api)
     */
    constructor(id, name, courtSystemId, status, courthouse) {
        this.id = id;
        this.name = name;
        this.courtSystemId = courtSystemId;
        this.status = status;
        this.courthouse = courthouse;
    }
}
__decorate([
    Type(() => Courthouse),
    __metadata("design:type", Courthouse
    /**
     * A room in a courthouse where hearings take place
     * @param id Identifies the courtroom
     * @param name The name or number of the courtroom
     * @param courtSystemId Which courtsystem the courtroom belongs to
     * @param status The status of this courtroom, i.e. active, archived or historical
     * @param courthouse The courthouse that the courtroom is in (undefined if not loaded by the api)
     */
    )
], Courtroom.prototype, "courthouse", void 0);
